<template>
                  <v-card  :loading="coursesCopyStatus===1">
                    <v-card-title>
                      <span class="headline">Kopiowanie grup</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                          <v-row>          
                            <v-col cols="5">
                              <v-select v-model="source" :error-messages="sourceErrors" :items="lookups.years" hide-details="auto" label="Kopiuj Z" ></v-select>
                            </v-col>    
                            <v-col cols="2" align="center" justify="center">
                              <v-icon size="30" class="mt-4">mdi-arrow-right-thick</v-icon>
                            </v-col>       
                            <v-col cols="5">
                              <v-select v-model="destination" :items="lookups.years" hide-details label="Kopiuj DO" ></v-select>
                              <!-- <v-text-field 
                                v-model="editedItem.amount" 
                                :error-messages="amountErrors" required 
                                @input="$v.editedItem.amount.$touch()"  
                                persistent-hint
                                hint="Nadpłata - ktowa ujemna"
                                @blur="$v.editedItem.amount.$touch()" label="Kwota"></v-text-field>                             -->
                            </v-col>
                          </v-row>
                          <v-row dense>
                            <v-col cols="12">
                              <v-checkbox v-model="users" label="Kopiuj nauczycieli" />
                            </v-col>
                          </v-row>
                        
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close()">Anuluj</v-btn>
                      <v-btn color="primary darken-1" text @click="handleSubmit" >Kopiuj</v-btn>
                    </v-card-actions>
                  </v-card>
</template>

<script>
  import required from 'vuelidate/lib/validators/required'

  export default {
    data: () => ({
        source:undefined,
        users:false
    }),
    props:['destination'],
    validations: {
      source:{
         required,
      }
    },
    watch: {
        coursesCopyStatus(val){
            if(val==2){
                this.close();
            }
        }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      coursesCopyStatus(){
        return this.$store.getters.getCoursesCopyStatus();
      },
      sourceErrors () {
        const errors = []
        if (!this.$v.source.$dirty) return errors
        !this.$v.source.required && errors.push('Żródło jest wymagane')
        return errors
      },
    },
 
    methods: {
      close(){
        this.$v.$reset();
        this.source = undefined;
        this.users = false;
        this.$emit('close');
      },
       handleSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {

        } else {
                this.$store.dispatch( 'copyCourses', {
                  source:  this.source,
                  destination:  this.destination,
                  users:  this.users
              });

        }
      },
    },
  }
</script>
<style scoped>
.choose_year{
      max-width: 150px;
}
</style>

